import { render, staticRenderFns } from "./BudgetAllocated.vue?vue&type=template&id=cfcfc726"
import script from "./BudgetAllocated.vue?vue&type=script&lang=js"
export * from "./BudgetAllocated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports